import type { ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';

type Props = ComponentProps<'div'> & {
  variant?: 'outlined' | 'plain' | 'inset';
  overflow?: 'hidden' | 'visible';
};

export function Card({ className, variant = 'outlined', overflow, ...props }: Props) {
  return (
    <div
      className={twMerge(
        'flex flex-col gap-4',
        variant === 'outlined' && 'bg-primary-contrast rounded-lg p-4 border border-secondary-300',
        variant === 'inset' && 'bg-secondary-50 rounded-lg p-4',
        (overflow ?? (variant === 'outlined' ? 'hidden' : 'visible')) === 'hidden' ? 'overflow-hidden' : 'overflow-visible',
        className,
      )}
      {...props}
    />
  );
}
